import { Grid } from '@material-ui/core'
import { useState, useEffect } from 'react'
import CaritraWidget from './Widget'
import CaritraWidgetStaffSelection from './StaffSelection'
const CaritraWidgetPrivateHandler = (props) => {
    const { widgetInfo, setError } = props
    const [staffIndex, setStaffIndex] = useState(null)

    useEffect(() => {
        setStaffIndex(null)
        if (widgetInfo) {
            if (widgetInfo.staffDetails.length > 0) {
                setStaffIndex(0)
            }
            else {
                setError("No staff available for selection.")
            }
        }
        else {
            setError("Widget info is missing")
        }
    }, [setError, widgetInfo])

    if (staffIndex !== null) {
        return (
            <Grid container style={{
                backgroundColor: widgetInfo.widgetColor.backgroundColor
            }}>
                <Grid item xs={12}>
                    <CaritraWidgetStaffSelection
                        {...{ staffIndex, setStaffIndex, widgetInfo }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <CaritraWidget {...{ setError, widgetInfo, staffIndex }} />
                </Grid>
            </Grid>
        )
    }
    else {
        return null
    }
}



export default CaritraWidgetPrivateHandler